
import React from 'react';
import { Link } from 'react-router-dom';

const Organizations = () => {
  return (
    <>
      {/* Page Header */}
      <section className="relative py-24 bg-cover bg-center bg-no-repeat" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1920&q=80')" }}>
        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>

        <div className="relative container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Top Organizations</h1>
          <div className="flex items-center text-white text-lg">
            <Link to="/" className="hover:text-primary-300 transition-colors duration-200">Home</Link>
            <i className="fas fa-chevron-right mx-3"></i>
            <span className="text-primary-300">Top Organizations</span>
          </div>
        </div>
      </section>

      {/* Organizations Search Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <form action="#" method="get" className="bg-gray-50 rounded-2xl p-8 shadow-lg">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                    <i className="fas fa-search text-gray-400"></i>
                  </div>
                  <input
                    type="text"
                    placeholder="Search organizations by name"
                    name="company"
                    className="w-full pl-12 pr-4 py-4 border border-gray-300 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-all duration-200"
                  />
                </div>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                    <i className="fas fa-briefcase text-gray-400"></i>
                  </div>
                  <select
                    name="industry"
                    className="w-full pl-12 pr-4 py-4 border border-gray-300 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-all duration-200 appearance-none bg-white"
                  >
                    <option value="">All Industries</option>
                    <option value="technology">Technology</option>
                    <option value="healthcare">Healthcare</option>
                    <option value="finance">Finance & Banking</option>
                    <option value="retail">Retail</option>
                    <option value="hospitality">Hospitality & Tourism</option>
                    <option value="construction">Construction</option>
                    <option value="education">Education</option>
                    <option value="government">Government</option>
                    <option value="oil-gas">Oil & Gas</option>
                    <option value="transportation">Transportation</option>
                  </select>
                </div>
                <button
                  type="submit"
                  className="bg-primary-600 hover:bg-primary-700 text-white font-semibold py-4 px-8 rounded-xl transition-all duration-200 transform hover:scale-105 focus:ring-4 focus:ring-primary-200"
                >
                  Search Organizations
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* Featured Organizations Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Featured Organizations</h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">Top companies hiring in Dubai and across UAE</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden group cursor-pointer" onClick={() => window.location.href='/organization/tech-solutions-llc'}>
              <div className="p-8">
                <div className="flex items-center justify-center w-20 h-20 mx-auto mb-6 bg-gray-100 rounded-xl group-hover:bg-primary-50 transition-colors duration-300">
                  <img src="https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=150&h=150&q=80" alt="Emirates Logo" className="w-16 h-16 object-contain" />
                </div>
                <div className="text-center">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">Emirates Group</h3>
                  <div className="space-y-2 mb-6">
                    <div className="flex items-center justify-center text-gray-600">
                      <i className="fas fa-map-marker-alt text-primary-500 mr-2"></i>
                      <span>Dubai, UAE</span>
                    </div>
                    <div className="flex items-center justify-center text-gray-600">
                      <i className="fas fa-briefcase text-primary-500 mr-2"></i>
                      <span>Aviation & Airlines</span>
                    </div>
                  </div>
                  <p className="text-gray-600 mb-8 leading-relaxed">
                    The Emirates Group is a Dubai-based international aviation holding company headquartered in Dubai, United Arab Emirates.
                  </p>
                  <div className="grid grid-cols-2 gap-4 mb-8">
                    <div className="text-center">
                      <div className="text-3xl font-bold text-primary-600 mb-1">120+</div>
                      <div className="text-sm text-gray-500">Open Jobs</div>
                    </div>
                    <div className="text-center">
                      <div className="text-3xl font-bold text-primary-600 mb-1">4.5</div>
                      <div className="text-sm text-gray-500 flex items-center justify-center">
                        <i className="fas fa-star text-yellow-400 mr-1"></i>
                        Rating
                      </div>
                    </div>
                  </div>
                  <Link to="/organization/tech-solutions-llc" className="inline-flex items-center px-6 py-3 border-2 border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-semibold rounded-xl transition-all duration-200 transform hover:scale-105">
                    View Profile
                  </Link>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden group cursor-pointer" onClick={() => window.location.href='/organization/digital-solutions'}>
              <div className="p-8">
                <div className="flex items-center justify-center w-20 h-20 mx-auto mb-6 bg-gray-100 rounded-xl group-hover:bg-primary-50 transition-colors duration-300">
                  <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=150&h=150&q=80" alt="Emaar Logo" className="w-16 h-16 object-contain" />
                </div>
                <div className="text-center">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">Emaar Properties</h3>
                  <div className="space-y-2 mb-6">
                    <div className="flex items-center justify-center text-gray-600">
                      <i className="fas fa-map-marker-alt text-primary-500 mr-2"></i>
                      <span>Dubai, UAE</span>
                    </div>
                    <div className="flex items-center justify-center text-gray-600">
                      <i className="fas fa-briefcase text-primary-500 mr-2"></i>
                      <span>Real Estate & Construction</span>
                    </div>
                  </div>
                  <p className="text-gray-600 mb-8 leading-relaxed">
                    Emaar Properties is one of the largest real estate developers in the UAE and is known for various large-scale projects.
                  </p>
                  <div className="grid grid-cols-2 gap-4 mb-8">
                    <div className="text-center">
                      <div className="text-3xl font-bold text-primary-600 mb-1">85+</div>
                      <div className="text-sm text-gray-500">Open Jobs</div>
                    </div>
                    <div className="text-center">
                      <div className="text-3xl font-bold text-primary-600 mb-1">4.3</div>
                      <div className="text-sm text-gray-500 flex items-center justify-center">
                        <i className="fas fa-star text-yellow-400 mr-1"></i>
                        Rating
                      </div>
                    </div>
                  </div>
                  <Link to="/organization/digital-solutions" className="inline-flex items-center px-6 py-3 border-2 border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-semibold rounded-xl transition-all duration-200 transform hover:scale-105">
                    View Profile
                  </Link>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden group cursor-pointer" onClick={() => window.location.href='/organization/cloud-systems'}>
              <div className="p-8">
                <div className="flex items-center justify-center w-20 h-20 mx-auto mb-6 bg-gray-100 rounded-xl group-hover:bg-primary-50 transition-colors duration-300">
                  <img src="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=150&h=150&q=80" alt="Etisalat Logo" className="w-16 h-16 object-contain" />
                </div>
                <div className="text-center">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">Etisalat</h3>
                  <div className="space-y-2 mb-6">
                    <div className="flex items-center justify-center text-gray-600">
                      <i className="fas fa-map-marker-alt text-primary-500 mr-2"></i>
                      <span>Abu Dhabi, UAE</span>
                    </div>
                    <div className="flex items-center justify-center text-gray-600">
                      <i className="fas fa-briefcase text-primary-500 mr-2"></i>
                      <span>Telecommunications</span>
                    </div>
                  </div>
                  <p className="text-gray-600 mb-8 leading-relaxed">
                    Etisalat is a multinational Emirati telecommunications services provider, operating in 16 countries across Asia, the Middle East, and Africa.
                  </p>
                  <div className="grid grid-cols-2 gap-4 mb-8">
                    <div className="text-center">
                      <div className="text-3xl font-bold text-primary-600 mb-1">65+</div>
                      <div className="text-sm text-gray-500">Open Jobs</div>
                    </div>
                    <div className="text-center">
                      <div className="text-3xl font-bold text-primary-600 mb-1">4.1</div>
                      <div className="text-sm text-gray-500 flex items-center justify-center">
                        <i className="fas fa-star text-yellow-400 mr-1"></i>
                        Rating
                      </div>
                    </div>
                  </div>
                  <Link to="/organization/cloud-systems" className="inline-flex items-center px-6 py-3 border-2 border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-semibold rounded-xl transition-all duration-200 transform hover:scale-105">
                    View Profile
                  </Link>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden group cursor-pointer" onClick={() => window.location.href='/organization/innovative-tech'}>
              <div className="p-8">
                <div className="flex items-center justify-center w-20 h-20 mx-auto mb-6 bg-gray-100 rounded-xl group-hover:bg-primary-50 transition-colors duration-300">
                  <img src="https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=150&h=150&q=80" alt="Jumeirah Logo" className="w-16 h-16 object-contain" />
                </div>
                <div className="text-center">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">Jumeirah Group</h3>
                  <div className="space-y-2 mb-6">
                    <div className="flex items-center justify-center text-gray-600">
                      <i className="fas fa-map-marker-alt text-primary-500 mr-2"></i>
                      <span>Dubai, UAE</span>
                    </div>
                    <div className="flex items-center justify-center text-gray-600">
                      <i className="fas fa-briefcase text-primary-500 mr-2"></i>
                      <span>Hospitality & Tourism</span>
                    </div>
                  </div>
                  <p className="text-gray-600 mb-8 leading-relaxed">
                    Jumeirah Group is a global luxury hotel company and a member of Dubai Holding, operating a portfolio of hotels and resorts.
                  </p>
                  <div className="grid grid-cols-2 gap-4 mb-8">
                    <div className="text-center">
                      <div className="text-3xl font-bold text-primary-600 mb-1">110+</div>
                      <div className="text-sm text-gray-500">Open Jobs</div>
                    </div>
                    <div className="text-center">
                      <div className="text-3xl font-bold text-primary-600 mb-1">4.4</div>
                      <div className="text-sm text-gray-500 flex items-center justify-center">
                        <i className="fas fa-star text-yellow-400 mr-1"></i>
                        Rating
                      </div>
                    </div>
                  </div>
                  <Link to="/organization/innovative-tech" className="inline-flex items-center px-6 py-3 border-2 border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-semibold rounded-xl transition-all duration-200 transform hover:scale-105">
                    View Profile
                  </Link>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden group cursor-pointer" onClick={() => window.location.href='/organization/global-systems-inc'}>
              <div className="p-8">
                <div className="flex items-center justify-center w-20 h-20 mx-auto mb-6 bg-gray-100 rounded-xl group-hover:bg-primary-50 transition-colors duration-300">
                  <img src="https://images.unsplash.com/photo-1578662996442-48f60103fc96?auto=format&fit=crop&w=150&h=150&q=80" alt="ADNOC Logo" className="w-16 h-16 object-contain" />
                </div>
                <div className="text-center">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">ADNOC Group</h3>
                  <div className="space-y-2 mb-6">
                    <div className="flex items-center justify-center text-gray-600">
                      <i className="fas fa-map-marker-alt text-primary-500 mr-2"></i>
                      <span>Abu Dhabi, UAE</span>
                    </div>
                    <div className="flex items-center justify-center text-gray-600">
                      <i className="fas fa-briefcase text-primary-500 mr-2"></i>
                      <span>Oil & Gas</span>
                    </div>
                  </div>
                  <p className="text-gray-600 mb-8 leading-relaxed">
                    Abu Dhabi National Oil Company is a state-owned oil company of the United Arab Emirates and one of the world's largest energy producers.
                  </p>
                  <div className="grid grid-cols-2 gap-4 mb-8">
                    <div className="text-center">
                      <div className="text-3xl font-bold text-primary-600 mb-1">95+</div>
                      <div className="text-sm text-gray-500">Open Jobs</div>
                    </div>
                    <div className="text-center">
                      <div className="text-3xl font-bold text-primary-600 mb-1">4.2</div>
                      <div className="text-sm text-gray-500 flex items-center justify-center">
                        <i className="fas fa-star text-yellow-400 mr-1"></i>
                        Rating
                      </div>
                    </div>
                  </div>
                  <Link to="/organization/global-systems-inc" className="inline-flex items-center px-6 py-3 border-2 border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-semibold rounded-xl transition-all duration-200 transform hover:scale-105">
                    View Profile
                  </Link>
                </div>
              </div>
            </div>

            {/* Organization 6 */}
            <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden group cursor-pointer" onClick={() => window.location.href='/organization/global-marketing-group'}>
              <div className="p-8">
                <div className="flex items-center justify-center w-20 h-20 mx-auto mb-6 bg-gray-100 rounded-xl group-hover:bg-primary-50 transition-colors duration-300">
                  <img src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=150&h=150&q=80" alt="Dubai Holding Logo" className="w-16 h-16 object-contain" />
                </div>
                <div className="text-center">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">Dubai Holding</h3>
                  <div className="space-y-2 mb-6">
                    <div className="flex items-center justify-center text-gray-600">
                      <i className="fas fa-map-marker-alt text-primary-500 mr-2"></i>
                      <span>Dubai, UAE</span>
                    </div>
                    <div className="flex items-center justify-center text-gray-600">
                      <i className="fas fa-briefcase text-primary-500 mr-2"></i>
                      <span>Investment & Development</span>
                    </div>
                  </div>
                  <p className="text-gray-600 mb-8 leading-relaxed">
                    Dubai Holding is an investment company with operations in 13 countries and employing over 20,000 people across various sectors.
                  </p>
                  <div className="grid grid-cols-2 gap-4 mb-8">
                    <div className="text-center">
                      <div className="text-3xl font-bold text-primary-600 mb-1">70+</div>
                      <div className="text-sm text-gray-500">Open Jobs</div>
                    </div>
                    <div className="text-center">
                      <div className="text-3xl font-bold text-primary-600 mb-1">4.0</div>
                      <div className="text-sm text-gray-500 flex items-center justify-center">
                        <i className="fas fa-star text-yellow-400 mr-1"></i>
                        Rating
                      </div>
                    </div>
                  </div>
                  <Link to="/organization/global-marketing-group" className="inline-flex items-center px-6 py-3 border-2 border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-semibold rounded-xl transition-all duration-200 transform hover:scale-105">
                    View Profile
                  </Link>
                </div>
              </div>
            </div>
          </div>


        </div>
      </section>

      {/* Top Industries Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Top Industries in UAE</h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">Explore organizations by industry</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            <Link to="/organizations?industry=technology" className="group bg-gray-50 hover:bg-primary-50 rounded-2xl p-8 text-center transition-all duration-300 transform hover:-translate-y-2 hover:shadow-lg">
              <div className="w-16 h-16 bg-primary-100 group-hover:bg-primary-500 rounded-xl flex items-center justify-center mx-auto mb-4 transition-colors duration-300">
                <i className="fas fa-microchip text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Technology</h3>
              <span className="text-gray-600 group-hover:text-primary-600 transition-colors duration-300">120+ Companies</span>
            </Link>

            <Link to="/organizations?industry=finance" className="group bg-gray-50 hover:bg-primary-50 rounded-2xl p-8 text-center transition-all duration-300 transform hover:-translate-y-2 hover:shadow-lg">
              <div className="w-16 h-16 bg-primary-100 group-hover:bg-primary-500 rounded-xl flex items-center justify-center mx-auto mb-4 transition-colors duration-300">
                <i className="fas fa-landmark text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Finance & Banking</h3>
              <span className="text-gray-600 group-hover:text-primary-600 transition-colors duration-300">85+ Companies</span>
            </Link>

            <Link to="/organizations?industry=hospitality" className="group bg-gray-50 hover:bg-primary-50 rounded-2xl p-8 text-center transition-all duration-300 transform hover:-translate-y-2 hover:shadow-lg">
              <div className="w-16 h-16 bg-primary-100 group-hover:bg-primary-500 rounded-xl flex items-center justify-center mx-auto mb-4 transition-colors duration-300">
                <i className="fas fa-hotel text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Hospitality & Tourism</h3>
              <span className="text-gray-600 group-hover:text-primary-600 transition-colors duration-300">150+ Companies</span>
            </Link>

            <Link to="/organizations?industry=healthcare" className="group bg-gray-50 hover:bg-primary-50 rounded-2xl p-8 text-center transition-all duration-300 transform hover:-translate-y-2 hover:shadow-lg">
              <div className="w-16 h-16 bg-primary-100 group-hover:bg-primary-500 rounded-xl flex items-center justify-center mx-auto mb-4 transition-colors duration-300">
                <i className="fas fa-hospital text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Healthcare</h3>
              <span className="text-gray-600 group-hover:text-primary-600 transition-colors duration-300">95+ Companies</span>
            </Link>

            <Link to="/organizations?industry=retail" className="group bg-gray-50 hover:bg-primary-50 rounded-2xl p-8 text-center transition-all duration-300 transform hover:-translate-y-2 hover:shadow-lg">
              <div className="w-16 h-16 bg-primary-100 group-hover:bg-primary-500 rounded-xl flex items-center justify-center mx-auto mb-4 transition-colors duration-300">
                <i className="fas fa-shopping-cart text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Retail</h3>
              <span className="text-gray-600 group-hover:text-primary-600 transition-colors duration-300">130+ Companies</span>
            </Link>

            <Link to="/organizations?industry=construction" className="group bg-gray-50 hover:bg-primary-50 rounded-2xl p-8 text-center transition-all duration-300 transform hover:-translate-y-2 hover:shadow-lg">
              <div className="w-16 h-16 bg-primary-100 group-hover:bg-primary-500 rounded-xl flex items-center justify-center mx-auto mb-4 transition-colors duration-300">
                <i className="fas fa-hard-hat text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Construction</h3>
              <span className="text-gray-600 group-hover:text-primary-600 transition-colors duration-300">110+ Companies</span>
            </Link>

            <Link to="/organizations?industry=oil-gas" className="group bg-gray-50 hover:bg-primary-50 rounded-2xl p-8 text-center transition-all duration-300 transform hover:-translate-y-2 hover:shadow-lg">
              <div className="w-16 h-16 bg-primary-100 group-hover:bg-primary-500 rounded-xl flex items-center justify-center mx-auto mb-4 transition-colors duration-300">
                <i className="fas fa-oil-can text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Oil & Gas</h3>
              <span className="text-gray-600 group-hover:text-primary-600 transition-colors duration-300">65+ Companies</span>
            </Link>

            <Link to="/organizations?industry=education" className="group bg-gray-50 hover:bg-primary-50 rounded-2xl p-8 text-center transition-all duration-300 transform hover:-translate-y-2 hover:shadow-lg">
              <div className="w-16 h-16 bg-primary-100 group-hover:bg-primary-500 rounded-xl flex items-center justify-center mx-auto mb-4 transition-colors duration-300">
                <i className="fas fa-graduation-cap text-2xl text-primary-600 group-hover:text-white transition-colors duration-300"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Education</h3>
              <span className="text-gray-600 group-hover:text-primary-600 transition-colors duration-300">80+ Companies</span>
            </Link>
          </div>

          <div className="text-center mt-16">
            <Link to="/industries" className="inline-flex items-center px-8 py-4 border-2 border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-semibold rounded-xl transition-all duration-200 transform hover:scale-105">
              View All Industries
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Organizations;
